// extracted by mini-css-extract-plugin
export default {"terms_privacy1":"Privacy1_terms_privacy1__dHts1"};